import { render, staticRenderFns } from "./CompanyProgramJourneyBadges.vue?vue&type=template&id=1e573286"
import script from "./CompanyProgramJourneyBadges.vue?vue&type=script&lang=js"
export * from "./CompanyProgramJourneyBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports